import { createSelector } from 'reselect'
import routerSelectors from '@kaidam/fc-shared/src/frontend/store/selectors/router'
import { findRoute } from '@kaidam/fc-shared/src/frontend/router/utils'
import routes from '../../router/routes'

import {
  RootState,
} from '@kaidam/fc-shared/src/types/frontend/store_generic'

import {
  AppRoute,
} from '@kaidam/fc-shared/src/types/frontend/router'

export const fullRoute = createSelector(
  routerSelectors.name,
  (name) => name ? findRoute(routes as AppRoute<RootState>[], name) : null,
)

export const routeNameMap = createSelector(
  () => routes,
  routes => {
    const routeMap: {
      [name: string]: AppRoute,
    } = {}
    const addRoutes = (routes: AppRoute<any>[] | undefined, prefixes: string[] = []) => {
      if(!routes) return
      routes.forEach(route => {
        const routeParts = prefixes.concat([route.name])
        const routeName = routeParts.join('.')
        routeMap[routeName] = route
        addRoutes(route.children, routeParts)
      })
    }
    addRoutes(routes)
    return routeMap
  }
)

export default {
  fullRoute,
  routeNameMap,
}
